import { useEffect } from "react";

export default function RevSlider() {
  useEffect(() => {
    // Prevent duplicate loading
    if (window.revSliderLoaded) return;
    window.revSliderLoaded = true;

    const loadScript = (src) => {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        document.body.appendChild(script);
      });
    };

    async function initSlider() {
      // jQuery
      await loadScript(
        "https://ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.js"
      );

      // Revolution scripts
      await loadScript("/revslider/js/rbtools.min.js");
      await loadScript("/revslider/js/rs6.min.js");

      // Init slider
      if (window.jQuery) {
        const tpj = window.jQuery;

        if (window.RS_MODULES === undefined)
          window.RS_MODULES = {};

        if (window.RS_MODULES.modules === undefined)
          window.RS_MODULES.modules = {};

        window.revapi6 = tpj("#rev_slider_6_1");

        if (window.revapi6.revolution === undefined) {
          console.error("Slider Revolution not loaded");
          return;
        }

        window.revapi6.revolutionInit({
          revapi: "revapi6",
          DPR: "dpr",
          visibilityLevels: "1240,1240,1240,480",
          gridwidth: "1240,1240,1240,480",
          gridheight: "868,868,868,720",
          lazyType: "single",
          spinner: "spinner3",
          perspective: 600,
          perspectiveType: "local",
          editorheight: "868,768,960,720",
          responsiveLevels: "1240,1240,1240,480",

          navigation: {
            mouseScrollNavigation: false,
            wheelCallDelay: 1000,
            onHoverStop: false,

            bullets: {
              enable: true,
              style: "hephaistos",
              hide_over: 751,
              space: 16,
            },
          },

          progressBar: {
            color: "rgba(173,203,255,0.45)",
            vertical: "top",
            size: 5,
          },

          fallbacks: {
            allowHTML5AutoPlayOnAndroid: true,
          },
        });
      }
    }

    initSlider();
  }, []);

  return (
    <div>
      <link rel="stylesheet" href="/revslider/css/rs6.css" />

      <style>
        {`
    .tp-dottedoverlay.twoxtwo{
    background:rgba(0,0,0,.3)
}

#rev_slider_6_1_wrapper .hephaistos .tp-bullet{
    width:12px;
    height:12px;
    position:absolute;
    background:#999999;
    border:3px solid rgba(255,255,255,0.9);
    border-radius:50%;
    cursor:pointer;
}
`}
      </style>

      <div
        dangerouslySetInnerHTML={{
          __html: `

<rs-module-wrap
id="rev_slider_6_1_wrapper"
data-alias="mvtest"
data-source="gallery"
style="visibility:hidden;background:transparent;padding:0;margin:0 auto;"
    >

    <rs-module id="rev_slider_6_1" data-version="6.6.14">

 <rs-slides style="overflow: hidden; position: absolute;">
						<rs-slide style="position: absolute;" data-key="rs-31" data-title="Slide" data-thumb="/revslider/assets/mi05-thum-100x54.png" data-link="/great" data-tag="l" data-target="_self" data-seoz="front" data-duration="9000" data-anim="ms:1200;f:random;" data-in="o:0;sx:1.1;sy:1.1;m:true;row:5;col:5;" data-out="a:false;">
							<img src="/revslider/assets/dummy.png" alt="" class="rev-slidebg tp-rs-img rs-lazyload" data-lazyload="/revslider/assets/mi05-bg-PC.jpg" data-bg="p:center top;" data-no-retina>
<!--
							--><rs-layer
								id="slider-6-slide-31-layer-6" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:r;xo:130px,130px,130px,760px;yo:250px,250px,250px,160px;"
								data-text="l:22;a:inherit;"
								data-dim="w:200px,200px,200px,100px;h:200px,200px,200px,100px;"
								data-vbility="t,t,t,f"
								data-frame_1="st:3000;sp:500;sR:3000;"
								data-frame_999="o:0;st:w;sR:5500;"
								data-loop_0="xR:4px;yR:4px;oX:50;oY:50;"
								data-loop_999="xR:4px;yR:4px;crd:t;sp:2000;yys:t;yyf:t;"
								style="z-index:8;"
							><img src="/revslider/assets/dummy.png" alt="" class="tp-rs-img rs-lazyload" width="350" height="350" data-lazyload="/revslider/assets/mi05-img01.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-31-layer-16" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;y:m;"
								data-text="l:22;a:inherit;"
								data-dim="w:['750px','750px','750px','750px'];h:['162px','162px','162px','162px'];"
								data-vbility="t,t,t,f"
								data-frame_0="sX:cyc(1|2|0.5);"
								data-frame_1="st:300;sp:1500;sR:300;"
								data-frame_999="o:0;st:w;sR:7200;"
								style="z-index:5;"
							><img src="/revslider/assets/dummy.png" alt="" class="tp-rs-img rs-lazyload" width="867" height="187" data-lazyload="/revslider/assets/mi05-logo.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-31-layer-19" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:r;xo:60px,60px,60px,10px;y:t,t,t,m;yo:230px,230px,230px,-30px;"
								data-text="l:22;a:inherit;"
								data-dim="w:200px,200px,200px,100px;h:200px,200px,200px,100px;"
								data-vbility="f,f,f,t"
								data-frame_1="st:3000;sp:500;sR:3000;"
								data-frame_999="o:0;st:w;sR:5500;"
								data-loop_0="xR:4px;yR:4px;oX:50;oY:50;"
								data-loop_999="xR:4px;yR:4px;crd:t;sp:2000;yys:t;yyf:t;"
								style="z-index:13;"
							><img src="/revslider/assets/dummy.png" alt="" class="tp-rs-img rs-lazyload" width="350" height="350" data-lazyload="/revslider/assets/mi05-img01.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-31-layer-20" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;xo:5px,5px,5px,0;y:m;yo:5px,5px,5px,30px;"
								data-text="l:22;a:inherit;"
								data-dim="w:867px,867px,867px,100%;h:187px,187px,187px,auto;"
								data-vbility="f,f,f,t"
								data-basealign="slide"
								data-padding="r:0,0,0,60;l:0,0,0,60;"
								data-frame_0="sX:cyc(1|2|0.5);"
								data-frame_1="st:300;sp:1500;sR:300;"
								data-frame_999="o:0;st:w;sR:7200;"
								style="z-index:10;"
							><img src="/revslider/assets/dummy.png" alt="" class="tp-rs-img rs-lazyload" width="867" height="187" data-lazyload="/revslider/assets/mi05-logo.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-31-layer-22" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:l,l,l,c;y:t,t,t,m;yo:-230px;"
								data-text="l:0,0,0,22;a:left,left,left,inherit;"
								data-dim="w:auto,auto,auto,100%;"
								data-vbility="f,f,f,t"
								data-basealign="slide"
								data-padding="r:0,0,0,60;l:0,0,0,60;"
								data-frame_0="x:-50px;"
								data-frame_1="e:power2.out;st:1700;sR:1700;"
								data-frame_999="o:0;st:w;sR:7000;"
								style="z-index:11;"
							><img src="/revslider/assets/dummy.png" alt="ケアンズ旅行・観光のことはジェイさんツアーにおまかせ！" class="tp-rs-img rs-lazyload" width="670" height="139" data-lazyload="/revslider/assets/mi05-txt01-sp.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-31-layer-23" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:l,l,l,c;y:t,t,t,m;yo:-130px;"
								data-text="l:0,0,0,22;a:left,left,left,inherit;"
								data-dim="w:auto,auto,auto,100%;"
								data-vbility="f,f,f,t"
								data-basealign="slide"
								data-frame_0="x:-50px;"
								data-frame_1="e:power2.in;st:2200;sp:600;sR:2200;"
								data-frame_999="o:0;st:w;sR:6200;"
								style="z-index:12;"
							><img src="/revslider/assets/dummy.png" alt="ケアンズのオプショナルツアー専門" class="tp-rs-img rs-lazyload" width="778" height="193" data-lazyload="/revslider/assets/mi05-txt02-sp.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-31-layer-24" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;y:m;yo:200px;"
								data-text="l:22;a:inherit;"
								data-dim="w:['100%','100%','100%','100%'];"
								data-vbility="f,f,f,t"
								data-basealign="slide"
								data-padding="r:10;l:10;"
								data-frame_0="sX:cyc(1|2|0.5);"
								data-frame_1="st:3700;sp:600;sR:3700;"
								data-frame_999="o:0;st:w;sR:4700;"
								style="z-index:14;"
							><img src="/revslider/assets/dummy.png" alt="アットホームな現地ツアー会社だから、お客様に選んでいただけております" class="tp-rs-img rs-lazyload" width="680" height="120" data-lazyload="/revslider/assets/mi05-txt03.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-31-layer-26" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;yo:120px;"
								data-text="l:22;a:inherit;"
								data-dim="w:['750px','750px','750px','750px'];h:['45px','45px','45px','45px'];"
								data-vbility="t,t,t,f"
								data-frame_1="e:easeInQuart;st:1700;sp:600;sR:1700;"
								data-frame_999="o:0;st:w;sR:6700;"
								style="z-index:6;"
							><img src="/revslider/assets/dummy.png" alt="ケアンズ旅行・観光のことはジェイさんツアーにおまかせ！" class="tp-rs-img rs-lazyload" width="1278" height="77" data-lazyload="/revslider/assets/mi05-txt01-pc.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-31-layer-27" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;yo:170px;"
								data-text="l:22;a:inherit;"
								data-dim="w:['1000px','1000px','1000px','1000px'];h:['83px','83px','83px','83px'];"
								data-vbility="t,t,t,f"
								data-frame_0="x:-50px;"
								data-frame_1="st:2200;sp:600;sR:2200;"
								data-frame_999="o:0;st:w;sR:6200;"
								style="z-index:7;"
							><img src="/revslider/assets/dummy.png" alt="ケアンズのオプショナルツアー専門" class="tp-rs-img rs-lazyload" width="1791" height="148" data-lazyload="/revslider/assets/mi05-txt02-pc.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-31-layer-28" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;y:b;yo:140px;"
								data-text="l:22;a:inherit;"
								data-dim="w:['680px','680px','680px','680px'];h:['120px','120px','120px','120px'];"
								data-vbility="t,t,t,f"
								data-frame_0="sX:cyc(1|2|0.5);"
								data-frame_1="st:3700;sp:600;sR:3700;"
								data-frame_999="o:0;st:w;sR:4700;"
								style="z-index:9;"
							><img src="/revslider/assets/dummy.png" alt="アットホームな現地ツアー会社だから、お客様に選んでいただけております" class="tp-rs-img rs-lazyload" width="680" height="120" data-lazyload="/revslider/assets/mi05-txt03.png" data-no-retina> 
							</rs-layer><!--
-->						</rs-slide>
						<rs-slide style="position: absolute;" data-key="rs-27" data-title="Slide" data-thumb="/revslider/assets/mi04-thum-100x54.png" data-link="/tours/219382" data-tag="l" data-target="_self" data-seoz="front" data-duration="7010" data-anim="f:random;" data-in="o:0;sx:1.1;sy:1.1;m:true;row:5;col:5;" data-out="a:false;">
							<img src="/revslider/assets/dummy.png" alt="" class="rev-slidebg tp-rs-img rs-lazyload" data-lazyload="/revslider/assets/mi04-bg-pc.png" data-bg="p:center bottom;" data-panzoom="d:10000;e:power1.in;ss:100;se:115;" data-no-retina>
<!--
							--><rs-layer
								id="slider-6-slide-27-layer-40" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:l,l,l,c;xo:30px,30px,30px,0;yo:30px;"
								data-text="l:22;a:inherit;"
								data-dim="w:201px,201px,201px,100px;h:166px,166px,166px,83px;"
								data-frame_0="x:50px;sX:ran(0|10);sY:ran(0|10);rX:1deg;rY:ran(-90|90);rZ:ran(-360|360);"
								data-frame_1="e:power0.in;st:150;sp:510;sR:150;"
								data-frame_999="o:0;e:nothing;st:w;sR:6350;"
								style="z-index:6;"
							><img src="/revslider/assets/dummy.png" alt="ジェイさんのアイコン" class="tp-rs-img rs-lazyload" width="361" height="298" data-lazyload="/revslider/assets/logo_Jaysan@2x-1.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-27-layer-41" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:r,r,r,c;xo:60px,60px,60px,0;y:t,t,t,m;yo:32px,32px,32px,-100px;"
								data-text="l:22;a:inherit;"
								data-dim="w:900px,900px,900px,460px;h:166px,166px,166px,44px;"
								data-vbility="t,t,t,f"
								data-frame_0="sX:0.8;sY:0.8;"
								data-frame_1="e:power4.out;st:150;sp:2000;sR:150;"
								data-frame_999="o:0;e:nothing;st:w;sR:4860;"
								style="z-index:7;"
							><img src="/revslider/assets/dummy.png" alt="神秘的なパワースポット　パロネラパークツアー" class="tp-rs-img rs-lazyload" width="1380" height="254" data-lazyload="/revslider/assets/mi04_txt1-pc.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-27-layer-42" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;y:m;yo:-50px,-50px,-50px,162px;"
								data-text="l:22;a:inherit;"
								data-dim="w:600px,600px,600px,300px;h:283px,283px,283px,190px;"
								data-vbility="t,t,t,f"
								data-frame_1="e:power4.inOut;st:1000;sp:1500;sR:1000;"
								data-frame_999="o:0;e:nothing;st:w;sR:4510;"
								style="z-index:9;"
							><img src="/revslider/assets/dummy.png" alt="インスタ映えポイントが多いから素敵な写真をたくさん撮ろう" class="tp-rs-img rs-lazyload" width="806" height="380" data-lazyload="/revslider/assets/mi04-item-pc.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-27-layer-45" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;y:b;yo:60px,60px,60px,20px;"
								data-text="l:22;a:inherit;"
								data-dim="w:1000px,1000px,1000px,450px;h:62px,62px,62px,NaN;"
								data-vbility="t,t,t,f"
								data-frame_1="st:2500;sp:500;sR:2500;"
								data-frame_999="o:0;st:w;sR:4010;"
								data-loop_0="x:-15;"
								data-loop_999="x:15;sp:4000;e:power0.in;yym:t;yys:t;yyf:t;"
								style="z-index:11;"
							><img src="/revslider/assets/dummy.png" alt="昼と夜のパロネラパークを一度にまとめて体験できるのは、ジェイさんツアーだけ♪" class="tp-rs-img rs-lazyload" width="1809" height="112" data-lazyload="/revslider/assets/mi04-txt2-pc.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-27-layer-55" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;y:b;yo:140px,140px,140px,115px;"
								data-text="l:22;a:inherit;"
								data-dim="w:400px,400px,400px,240px;h:67px,67px,67px,40px;"
								data-frame_1="st:2800;sp:500;sR:2800;"
								data-frame_999="o:0;st:w;sR:3710;"
								style="z-index:13;"
							><img src="/revslider/assets/dummy.png" alt="安心の日本語ガイド付き" class="tp-rs-img rs-lazyload" width="480" height="80" data-lazyload="/revslider/assets/mi04-txt3-pc.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-27-layer-57" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;y:m;yo:140px,140px,140px,160px;"
								data-text="l:22;a:inherit;"
								data-dim="w:400px,400px,400px,240px;h:65px,65px,65px,39px;"
								data-frame_1="st:2100;sp:400;sR:2100;"
								data-frame_999="o:0;st:w;sR:4510;"
								style="z-index:14;"
							><img src="/revslider/assets/dummy.png" alt="#ジェイさんツアー" class="tp-rs-img rs-lazyload" width="575" height="93" data-lazyload="/revslider/assets/mi04_txt4-1.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-27-layer-58" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:l,l,l,c;yo:125px,125px,125px,135px;"
								data-text="l:0,0,0,22;a:left,left,left,inherit;"
								data-dim="w:auto,auto,auto,360px;h:auto,auto,auto,127px;"
								data-vbility="f,f,f,t"
								data-frame_1="st:150;sp:2000;sR:150;"
								data-frame_999="o:0;st:w;sR:4860;"
								style="z-index:8;"
							><img src="/revslider/assets/dummy.png" alt="神秘的なパワースポット　パロネラパークツアー" class="tp-rs-img rs-lazyload" width="742" height="262" data-lazyload="/revslider/assets/mi04-txt1-sp.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-27-layer-59" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:l,l,l,c;y:t,t,t,m;yo:70px,70px,70px,15px;"
								data-text="l:0,0,0,22;a:left,left,left,inherit;"
								data-dim="w:auto,auto,auto,280px;h:auto,auto,auto,192px;"
								data-vbility="f,f,f,t"
								data-frame_1="st:1000;sp:1500;sR:1000;"
								data-frame_999="o:0;st:w;sR:4510;"
								style="z-index:10;"
							><img src="/revslider/assets/dummy.png" alt="インスタ映えポイントが多いから素敵な写真をたくさん撮ろう" class="tp-rs-img rs-lazyload" width="530" height="364" data-lazyload="/revslider/assets/mi04-item-sp.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-27-layer-60" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:l,l,l,c;y:t,t,t,b;yo:0,0,0,20px;"
								data-text="l:0,0,0,22;a:left,left,left,inherit;"
								data-dim="w:auto,auto,auto,350px;h:auto,auto,auto,79px;"
								data-vbility="f,f,f,t"
								data-frame_1="st:2500;sp:500;sR:2500;"
								data-frame_999="o:0;st:w;sR:4010;"
								style="z-index:12;"
							><img src="/revslider/assets/dummy.png" alt="昼と夜のパロネラパークを一度にまとめて体験できるのは、ジェイさんツアーだけ♪" class="tp-rs-img rs-lazyload" width="734" height="165" data-lazyload="/revslider/assets/mi04-txt2-sp.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-27-layer-62" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="y:m;"
								data-text="l:22;a:inherit;"
								data-dim="w:['100%','100%','100%','100%'];"
								data-vbility="f,f,f,t"
								data-basealign="slide"
								data-frame_1="sp:10;sR:10;"
								data-frame_999="o:0;st:w;sR:6990;"
								style="z-index:5;"
							><img src="/revslider/assets/dummy.png" alt="" class="tp-rs-img rs-lazyload" width="750" height="1624" data-lazyload="/revslider/assets/mi04-bg-sp.png" data-no-retina> 
							</rs-layer><!--
-->						</rs-slide>
						<rs-slide style="position: absolute;" data-key="rs-26" data-title="Slide" data-thumb="/revslider/assets/mi03-thum-100x54.png" data-duration="8000" data-anim="f:random;" data-in="o:0;sx:1.1;sy:1.1;m:true;row:5;col:5;" data-out="a:false;">
							<img src="/revslider/assets/dummy.png" alt="" class="rev-slidebg tp-rs-img rs-lazyload" data-lazyload="/revslider/assets/STO01.jpg" data-bg="p:left top;" data-panzoom="d:10000;e:power1.in;ss:100;se:115;be:10;os:-1920/0;oe:1920/-30;" data-no-retina>
<!--
							--><rs-layer
								id="slider-6-slide-26-layer-13" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="xo:2px,2px,2px,1px;yo:0,0,0,120px;"
								data-text="l:22;a:inherit;"
								data-dim="w:395px,395px,395px,160px;h:300px,300px,300px,121px;"
								data-actions='o:click;a:simplelink;target:_self;url:/tour-category/kuranda;'
								data-frame_1="st:500;sp:500;sR:500;"
								data-frame_999="o:0;e:nothing;st:w;sR:7000;"
								style="z-index:12;"
							><img src="/revslider/assets/dummy.png" alt="キュランダ列車のツアー【ケアンズツアーのことならジェイさんツアー】" class="tp-rs-img rs-lazyload" width="498" height="378" data-lazyload="/revslider/assets/mi02-img01@2x.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-26-layer-14" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;xo:1px;yo:0,0,0,120px;"
								data-text="l:22;a:inherit;"
								data-dim="w:395px,395px,395px,160px;h:300px,300px,300px,121px;"
								data-actions='o:click;a:simplelink;target:_self;url:/tour-category/animal-tour;'
								data-frame_1="st:1000;sp:500;sR:1000;"
								data-frame_999="o:0;e:nothing;st:w;sR:6500;"
								style="z-index:11;"
							><img src="/revslider/assets/dummy.png" alt="大自然動物探検ツアー！野生のワラビー餌付けを一番長く体験できるツアーはジェイさんツアーですよ！" class="tp-rs-img rs-lazyload" width="498" height="378" data-lazyload="/revslider/assets/mi02-img02@2x.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-26-layer-15" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:r;xo:-1px;yo:0,0,0,120px;"
								data-text="l:22;a:inherit;"
								data-dim="w:395px,395px,395px,160px;h:300px,300px,300px,121px;"
								data-actions='o:click;a:simplelink;target:_self;url:/tour-category/gbr;'
								data-frame_1="st:1500;sp:500;sR:1500;"
								data-frame_999="o:0;e:nothing;st:w;sR:6000;"
								style="z-index:10;"
							><img src="/revslider/assets/dummy.png" alt="グレートバリアリーフに関連するツアー【ケアンズツアーのことならジェイさんツアー】" class="tp-rs-img rs-lazyload" width="498" height="378" data-lazyload="/revslider/assets/mi02-img05@2x.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-26-layer-16" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="xo:2px;y:b;yo:0,0,0,120px;"
								data-text="l:22;a:inherit;"
								data-dim="w:395px,395px,395px,160px;h:300px,300px,300px,121px;"
								data-actions='o:click;a:simplelink;target:_self;url:/tour-category/aboriginy;'
								data-frame_1="st:3000;sp:500;sR:3000;"
								data-frame_999="o:0;e:nothing;st:w;sR:4500;"
								style="z-index:5;"
							><img src="/revslider/assets/dummy.png" alt="アボリジニ文化体験でお子様の夏休みや冬休みの宿題にいかが？【ケアンズツアーのことならジェイさんツアー】" class="tp-rs-img rs-lazyload" width="498" height="378" data-lazyload="/revslider/assets/mi02-img03@2x.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-26-layer-17" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:c;xo:2px;y:b;yo:0,0,0,120px;"
								data-text="l:22;a:inherit;"
								data-dim="w:395px,395px,395px,160px;h:300px,300px,300px,121px;"
								data-actions='o:click;a:simplelink;target:_self;url:/tour-category/greenisland;'
								data-frame_1="st:2500;sp:500;sR:2500;"
								data-frame_999="o:0;e:nothing;st:w;sR:5000;"
								style="z-index:6;"
							><img src="/revslider/assets/dummy.png" alt="グリーン島でのんびり過ごすケアンズ観光ツアー【ケアンズツアーのことならジェイさんツアー】" class="tp-rs-img rs-lazyload" width="498" height="378" data-lazyload="/revslider/assets/mi02-img04@2x.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-26-layer-18" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:r;xo:-2px;y:b;yo:0,0,0,120px;"
								data-text="l:22;a:inherit;"
								data-dim="w:395px,395px,395px,160px;h:300px,300px,300px,121px;"
								data-actions='o:click;a:simplelink;target:_self;url:/tour-category/ballooning;'
								data-frame_1="st:2000;sp:500;sR:2000;"
								data-frame_999="o:0;e:nothing;st:w;sR:5500;"
								style="z-index:7;"
							><img src="/revslider/assets/dummy.png" alt="圧倒的な世界観を目の当たりに！熱気球体験なら【ケアンズツアーのことならジェイさんツアー】" class="tp-rs-img rs-lazyload" width="498" height="378" data-lazyload="/revslider/assets/mi02-img06@2x.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-26-layer-19" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:r,r,r,c;xo:19px,19px,19px,0;y:m;yo:0,0,0,20px;"
								data-text="l:22;a:inherit;"
								data-dim="w:940px,940px,940px,460px;h:150px,150px,150px,73px;"
								data-frame_0="x:-50px;sX:1.5;sY:1.5;"
								data-frame_1="e:power0.in;st:3500;sp:500;sR:3500;"
								data-frame_999="o:0;e:nothing;st:w;sR:4000;"
								style="z-index:8;"
							><img src="/revslider/assets/dummy.png" alt="ジェイさんツアーは他店代理店や大手旅行代理店と同じ内容で最安値！" class="tp-rs-img rs-lazyload" width="1259" height="201" data-lazyload="/revslider/assets/mi02-txt01@2x.png" data-no-retina> 
							</rs-layer><!--

							--><rs-layer
								id="slider-6-slide-26-layer-20" 
								data-type="image"
								data-rsp_ch="on"
								data-xy="x:l,l,l,c;xo:51px,51px,51px,0;y:m;yo:0,0,0,-70px;"
								data-text="l:22;a:inherit;"
								data-dim="w:182px,182px,182px,100px;h:150px,150px,150px,83px;"
								data-frame_1="e:none;st:3500;sp:500;sR:3500;"
								data-frame_999="o:0;e:nothing;st:w;sR:4000;"
								data-loop_0="rZ:-10;oX:50;oY:50;"
								data-loop_999="rZ:10;sp:4000;yym:t;yyr:t;yys:t;yyf:t;"
								style="z-index:9;"
							><img src="/revslider/assets/dummy.png" alt="ケアンズのことならジェイさんツアー" class="tp-rs-img rs-lazyload" width="223" height="184" data-lazyload="/revslider/assets/logo02@2x.png" data-no-retina> 
							</rs-layer><!--
-->						</rs-slide>
					</rs-slides>

</rs-module>

</rs-module-wrap>

`,
        }}
      />
    </div>
  );
}
